import { connect } from 'react-redux'
import PlaceOrder from '../../../pages/main/PlaceOrders'
import { getIsGetSalesChannelListLoading } from '../../../redux/filter/selectors'
const mapStateToProps = (state) => ({
  isGetSalesChannelListLoading: getIsGetSalesChannelListLoading(state),
})

export default connect(mapStateToProps)(PlaceOrder)
